module.exports = __webpack_public_path__ + "static/logos-04-12776352159f32a1f12dbc22099bcfd2.png";